import { ref, type Ref } from "vue";
import type MultiChannelLink from "@/interface/MultiChannelLink";

export default function setMultiChannelInfo(
  multiChannel: Ref<MultiChannelLink>,
  prop: any
): void {
  multiChannel.value.acc = prop.acc ? prop.acc : "";
  multiChannel.value.bc = prop.bc ? prop.bc : "";
  multiChannel.value.rci = prop.rci ? prop.rci : "";
  multiChannel.value.mci = prop.mci ? prop.mci : "";
  multiChannel.value.mc = prop.mc ? prop.mc : "";
  multiChannel.value.crfn = prop.crfn ? prop.crfn : "";
}
